<script>
import userService from '../../services/user.js'
import myUpload from 'vue-image-crop-upload';

export default {
    name: "p-user-photo",
    components:{
        myUpload
    },
    data() {
        return {
            successMessage : "default",
            show: false,
            params: {
                "atualizar-foto-perfil": true,
            },
            headers: {
                smail: '*_~'
            },
            imgDataUrl: '' // the datebase64 url of created image
        }
    },
    methods: {
        toggleShow() {
                this.show = !this.show;
        },
        /**
         * crop success
         *
         * [param] imgDataUrl
         * [param] field
         */
        cropSuccess(imgDataUrl, field){
            this.imgDataUrl = imgDataUrl;
        },
        /**
         * upload success
         *
         * [param] jsonData  server api return data, already json encode
         * [param] field
         */
        cropUploadSuccess(jsonData, field){
            if (!jsonData.erro) {
                this.$emit('upload-success', jsonData.foto)
            }
        },
        /**
         * upload fail
         *
         * [param] status    server api return error status, like 500
         * [param] field
         */
        cropUploadFail(status, field){
            console.log('-------- upload fail --------');
            console.log(status);
            console.log('field: ' + field);
        }
    },
    created: function() {}
}
</script>
<template>
    <div class="wrapper">
       <button @click="toggleShow" class="btn btn-sm btn-success">Alterar foto</button>
        <!-- <a class="btn" @click="toggleShow">set avatar</a> -->
        <my-upload field="file"
             @crop-success="cropSuccess"
             @crop-upload-success="cropUploadSuccess"
             @crop-upload-fail="cropUploadFail"
             v-model="show"
             :width="300"
             :height="300"
             url="includes/php/ajax_update.php"
             :params="params"
             :headers="headers"
             img-format="png/jpg"
             langType="pt-br">
        </my-upload>
        <!-- <img :src="imgDataUrl"> -->
   </div>
</template>
<style lang="scss"></style>



// WEBPACK FOOTER //
// src/js/components/profile/p-user-photo.vue